import { useIsFocused } from "@-/com.npmjs.expo-router/react-navigation";
import useLatest from "@-/com.npmjs.use-latest";
import { subscribeLearnCards } from "@-/dev.improve.haniverse.routes.nav._lib.primary-navigation-strip";
import {
  useLearnMapModeSelector,
  useLeaveLearnMap,
} from "@-/dev.improve.haniverse.routes.nav.app.learn._lib.map-mode";
import { useEffect } from "react";

/**
 * A press of the focused Learn tab leaves Learn's map for the cards, as the map's top-left control
 * does: the tab stays Learn, and the cards are where it leads (`requestLearnCards`). Only the map
 * itself takes the press; a page opened over it dismisses as Learn always has.
 */
export function LearnMapTabPress() {
  const isLearnFocused = useIsFocused();
  const isMapShown = useLearnMapModeSelector((mode) => mode.isMapShown) ?? false;
  const leaveMapRef = useLatest(useLeaveLearnMap());
  useEffect(() => {
    if (!isLearnFocused || !isMapShown) {
      return;
    }
    return subscribeLearnCards(() => leaveMapRef.current());
  }, [isLearnFocused, isMapShown, leaveMapRef]);
  return null;
}
